import axios from 'axios'
const backendUrl = "http://headless.24bj.se/public/24-birger-jarl"

axios.defaults.withCredentials = true

const login = (email, password) => {
    return axios.post(backendUrl + '/auth/authenticate', {
        email,
        password,
        mode: 'cookie',
    }, {isSameSite: 'lax'}).catch((error) => error.response.data);
}

const logout = () => {
    return axios.post(backendUrl + '/auth/logout', {}, {isSameSite: 'lax'}).catch((error) => error.response.data);
}

const loggedIn = () => {
    return axios.get(backendUrl + '/users/me');
};

const publicArticles = () => {
    return axios.get(backendUrl + '/items/public').catch((error) => {
        console.log(error);
    })
}

const brothers = () => {
    return axios.get(backendUrl + '/items/brothers').catch(error => console.log(error))
}

const users = () => {
    return axios.get(backendUrl + '/users').catch((error) => {
        console.log(error);
    })
}

const file = (id) => {
    return axios.get(backendUrl + '/files/' + id).catch((error) => {
        console.log(error);
    })
}


const protocols = () => {
    return axios.get(backendUrl + '/items/protocols').catch((error) => {
        console.log(error);
    })
}

const meetings = () => {
    return axios.get(backendUrl + '/items/meetings').catch((error) => {
        console.log(error);
    })
}

const songs = () => {
    return axios.get(backendUrl + '/items/songs').catch((error) => {
        console.log(error);
    })
}

const attendance = () => {
    axios.get(backendUrl + '/items/attendance').then((response) => {
        console.log(response.data);
    }).catch((error) => {
        console.log(error);
    })
}

const archive = () => {
    axios.get(backendUrl + '/items/archive').then((response) => {
        console.log(response.data);
    }).catch((error) => {
        console.log(error);
    })
}

const committees = () => {
    return axios.get(backendUrl + '/items/committees').catch((error) => {
        console.log(error);
    })
}


export default {
    login,
    loggedIn,
    publicArticles,
    brothers,
    protocols,
    meetings,
    songs,
    attendance,
    archive,
    committees,
    logout,
    users,
    file
}
